import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { CookieService } from "ngx-cookie-service";

@Component({
  selector: "app-i-make-app",
  templateUrl: "./i-make-app.component.html",
  styleUrls: ["./i-make-app.component.css"],
})
export class IMakeAppComponent implements OnInit {
  clientsAppFeatures1: string[] = [
    "And mobile messages, and this provides the restaurant with large customer data for later use. The ability to register through otp",
    "Possibility to register with Facebook and Google",
    "The possibility of adding any number of products and dishes, as well as adding the features and options of each meal, and determining the price of each option",
    "Inform the customer of the best-selling products and foods in the restaurant",
    "The possibility of adding advertising spaces within the application, as well as pictures of new offers",
    "A basket with the products required by the customer, and the possibility of ordering the same product, but with different options",
    "The possibility of using discount coupons during the order",
    "The possibility of using the wallet during the request and making portfolio reports",
    "Withdrawal coupons system, in order to make a weekly or monthly withdrawal for a number of the best customers of the restaurant",
    "Possibility of real-time tracking of application statuses",
    "Continuous notifications to the customer of offers or of changing order statuses",
    "The possibility of evaluating the request and leaving a comment",
    "View the delivery cost, delivery time, and minimum order",
    "Frequently asked questions system and the possibility of making a complaint and sending it to the administration",
    "Android and ios native application",
  ];

  clientsAppFeatures2: string[] = [
    "The possibility of adding an unlimited number of offers and discounts",
    "Possibility of payment by cash, visa or master card",
    "The possibility of adding more than one address for the customer to choose from during the order",
    "Points system for customers and the possibility of transferring them to amounts in the wallet",
    "The friend invitation system, which is a financial system when a new customer joins through a previous customer",
    "The possibility of canceling the request at a specific time from the time the request was created",
    "The possibility of evaluating the request and leaving a comment",
    "View customer reviews",
    "Determine the delivery locations for the restaurant and compare them to the current customer location",
    "Changing the profile information and the customer picture",
    "Automatically update apps from within the app",
  ];

  deliveriesAppFeatures: string[] = [
    "Receiving and approving orders from the restaurant",
    "A daily account of all delegate requests and the cost of delivery service",
    "Draw a path between the delegate and the customer in each request",
    "Two apps ios - android",
    "The possibility of receiving more than one order at the same time",
    "Archive account for all delegate requests",
    "A button to deliver to the customer or cancel if a problem occurred during delivery, with a mention of the reason",
  ];

  dashboardFeatures1: string[] = [
    "Add your offers to customers and upload them to the mobile application",
    "Add a wallet for a specific customer or for a specific region",
    "Adding discount coupons and the ability to control them, the percentage of the discount, its users, and its duration",
    "Sending notices to clients or clients of a specific area",
    "Follow up on requests, receive them, and change their statuses",
    "A complete archive of requests, their dates, and their total",
    "The ability to control the colors of the website and the application",
    "Adding delegates to the restaurant and adding their papers and mattresses",
  ];

  dashboardFeatures2: string[] = [
    "An integrated financial system to know the financial status of the restaurant in each period, revenues and dues",
    "The possibility of adding and controlling the menu and adding options for each dish and its price",
    "The possibility of adding an unlimited number of branches to the restaurant, specifying the information of the managers",
    "Determine the working hours of each branch so that the work is done automatically within the application",
    "An internal notification system to follow up on all requests and all branches",
    "An internal complaints system between branches and departments inside the restaurant",
    "Adding advertising spaces within the application and the website",
    "Comprehensive reports of restaurant sales, order details, and the ability to filter them",
  ];

  branchDashboardFeatures: string[] = [
    "Possibility of receiving applications instantly and approved by me and knowing their details",
    "View the financial status of each branch and a financial report of profits and losses",
    "Comprehensive reports for the branch, including expenses, revenues, the most sold dishes, and graphs for all reports",
    "Add the branch delegates with their documents",
    "Adding and controlling branch tables",
  ];

  websitefeatures1: string[] = [
    "And mobile messages, and this provides the restaurant with large customer data for later use. The ability to register through otp",
    "Possibility to register with Facebook and Google",
    "The possibility of adding any number of products and dishes, as well as adding the features and options of each meal, and determining the price of each option",
    "Inform the customer of the best-selling products and dishes in the restaurant",
    "The possibility of adding advertising spaces within the application, as well as pictures of new offers",
    "A basket with the products required by the customer, and the possibility of ordering the same product, but with different options",
    "The possibility of using discount coupons during the order",
    "The possibility of using the wallet during the request and making portfolio reports",
    "Withdrawal coupons system, in order to make a weekly or monthly withdrawal for a number of the best customers of the restaurant",
    "Possibility of real-time tracking of application statuses",
    "Continuous notifications to the customer of offers or of changing order statuses",
    "The possibility of evaluating the request and leaving a comment",
    "View the delivery cost, delivery time, and minimum order",
    "Android and ios native application",
  ];

  websitefeatures2: string[] = [
    "The possibility of adding an unlimited number of offers and discounts",
    "Possibility of payment by cash, visa or master card",
    "The possibility of adding more than one address for the customer to choose from during the order",
    "Points system for customers and the possibility of transferring them to amounts in the wallet",
    "The friend invitation system, which is a financial system when a new customer joins through a previous customer",
    "The possibility of canceling the request at a specific time from the time the request was created",
    "The possibility of evaluating the request and leaving a comment",
    "Determine the delivery locations for the restaurant and compare them to the current customer location",
    "Changing the profile information and the customer picture",
    "Automatically update apps from within the app",
    "Frequently asked questions system and the possibility of making a complaint and sending it to the administration",
  ];

  waitersOrdersAppFeatures: string[] = [
    "Displaying restaurant tables and the possibility of opening and reserving a table",
    "Add the order and print it inside the kitchen and print it for the cashier",
    "Print the application after closing the table",
    "Reports of today's requests and linking them to every watt",
  ];

  ordersAppFeatures1: string[] = [
    "Receiving requests through the application in real time, using the technology of receiving requests in real time, and also setting a specific alarm for each new request",
    "The ability to see the details of the order, the required products, their number, and the total with taxes or discounts",
    "The ability to follow the representative on the map during the delivery of the request",
    "Archive of requests with history and cases of each request",
    "An application dedicated to each branch if you have more than one branch of a restaurant",
    "ios - android app for restaurant",
  ];

  ordersAppFeatures2: string[] = [
    "The possibility of closing the reception of requests through the application",
    "The possibility of sending the request to a representative inside the restaurant to deliver it",
    "Closing Talabat Al-Youm account and the account of each representative",
    "The possibility of rejecting the application, specifying the reason for rejection for each branch",
    "Sending a notice to the customer with a change in the status of the request",
  ];

  packages: any = [
    {
      type: "started",
      price: 29.99,
      description: "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
      features: [
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
      ],
    },
    {
      type: "professional",
      price: 59.99,
      description: "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
      features: [
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
      ],
    },
    {
      type: "advanced",
      price: 89.99,
      description: "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
      features: [
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
        "هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة",
      ],
    },
  ];

  constructor(
    private r: Router,
    private cookie_s: CookieService
  ) {}

  ngOnInit(): void {}

  play_video(video_obj: any, play_btn: any) {
    // play video
    video_obj.play();

    // hide play btn
    play_btn.classList.add("hide");

    // show play btn when video finish
    video_obj.addEventListener("ended", () => {
      // show play btn
      play_btn.classList.remove("hide");
    });
  }

  redirect_to_buy_package() {
    // check if user signed-in
    if (this.cookie_s.get('token')) {
      // signed in
      this.r.navigateByUrl("/create-package");
    } // not signed in
    else {
      // create flag
      this.cookie_s.set('wanna_buy_package', "true", undefined, '/' );

      // redirect to sign-in
      this.r.navigateByUrl("/auth/sign-in");
    }
  }
}
